module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"createFormInstanceModal\" title=\"Draft App Instance\" style=\"display: none; \">\r\n    <div class=\"row\" style=\"padding: 10px 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\">\r\n            You are about to create a new Draft App Instance.\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\">\r\n            Do you want the notifications to be redirected?\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 10px 0 0 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"redirect\" value='NO' checked/>\r\n        </div>\r\n        <div class=\" col-md-10\">\r\n            No. Send normally\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 5px 0 0 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"redirect\" value='YES'/>\r\n        </div>\r\n        <div class=\" col-md-10\">\r\n            Yes. Redirect to myself\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}